<template>
	<div
		v-if="
			appointment.chief_complaint ||
			appointment.history_illness ||
			appointment.past_medical ||
			appointment.family_history ||
			appointment.life_habits ||
			appointment.review_systems ||
			appointment.comparative_assessment ||
			appointment.drugs.length > 0 ||
			appointment.exam_description ||
			appointment.observations ||
			symptoms['chief_complaint'].length > 0 ||
			symptoms['history_illness'].length > 0 ||
			symptoms['past_medical'].length > 0 ||
			symptoms['family_history'].length > 0 ||
			symptoms['life_habits'].length > 0 ||
			symptoms['review_systems'].length > 0 ||
			symptoms['comparative_assessment'].length > 0 ||
			symptoms['chief_complaint'].length > 0 ||
			symptoms['chief_complaint'].length > 0
		"
	>
    <v-btn v-if="importOption" color="secondary" depressed small class="ml-2 mb-1 primary--text float-right" @click="importTopic('all')">
			<v-icon class="mr-1" small>mdi-calendar-import</v-icon>
			<translate>Import All</translate>
		</v-btn>
		<ClinicHistoryTopic
			:title="$gettext('Chief Complaint')"
			:text="appointment.chief_complaint"
			:chips="symptoms['chief_complaint']"
			key="chief_complaint"
      :importOption="this.importOption"
      @import="importTopic('chief_complaint')"
		/>
		<ClinicHistoryTopic
			:title="$gettext('History of the present illness')"
			:text="appointment.history_illness"
			:chips="symptoms['history_illness']"
			key="history_illness"
      :importOption="this.importOption"
      @import="importTopic('history_illness')"
		/>
		<ClinicHistoryTopic
			:title="$gettext('Past medical history')"
			:text="appointment.past_medical"
			:chips="symptoms['past_medical']"
			key="past_medical"
      :importOption="this.importOption"
      @import="importTopic('past_medical')"
		/>
		<ClinicHistoryTopic
			:title="$gettext('Family History')"
			:text="appointment.family_history"
			:chips="symptoms['family_history']"
			key="family_history"
      :importOption="this.importOption"
      @import="importTopic('family_history')"
		/>
		<ClinicHistoryTopic
			:title="$gettext('Life Habits')"
			:text="appointment.life_habits"
			:chips="symptoms['life_habits']"
			key="life_habits"
      :importOption="this.importOption"
      @import="importTopic('life_habits')"
		/>
		<ClinicHistoryTopic
			:title="$gettext('Review of Systems')"
			:text="appointment.review_systems"
			:chips="symptoms['review_systems']"
			key="review_systems"
      :importOption="this.importOption"
      @import="importTopic('review_systems')"
		/>
		<ClinicHistoryTopic
			:title="$gettext('Comparative Assessment')"
			:text="appointment.comparative_assessment"
			:chips="symptoms['comparative_assessment']"
			key="comparative_assessment"
      :importOption="this.importOption"
      @import="importTopic('comparative_assessment')"
		/>
		<ClinicHistoryTopic
			:title="$gettext('Drugs')"
			:text="appointment.drug_description"
			:chips="appointment.drugs"
			icon="drugs"
			key="drugs"
		/>
		<ClinicHistoryTopic
			:title="$gettext('Documents')"
			:chips="appointment.exam_description ? documents : []"
			icon="docs"
			key="docs"
		/>
		<ClinicHistoryTopic
			:title="$gettext('Observations')"
			:text="appointment.observations"
			key="obs"
      :importOption="this.importOption"
      @import="importTopic('observations')"
		/>
	</div>
	<p v-else class="font-weight-thin ml-2" v-translate key="no-anamnesis">
		No anamnesis.
	</p>
</template>

<script>
import ClinicHistoryTopic from "@/components/patient/ClinicHistoryTopic.vue";

export default {
	name: "ClinicHistoryAnamnesis",
  components: {
    ClinicHistoryTopic
  },
	props: ["appointment", "appSymptoms", "documents", "importOption"],
	data: () => ({}),
  methods: {
    importTopic(topic) {
      this.$emit('import-topic', this.appointment.id, topic);
    }
  },
  computed: {
    symptoms() {
      if(this.appSymptoms) return this.appSymptoms;
      const symptoms = {};
			symptoms["chief_complaint"] = [];
			symptoms["history_illness"] = [];
			symptoms["past_medical"] = [];
			symptoms["family_history"] = [];
			symptoms["life_habits"] = [];
			symptoms["comparative_assessment"] = [];
			symptoms["review_systems"] = [];
			symptoms["gen_diagnose"] = [];
			symptoms["mtc_diagnose"] = [];
			this.appointment.symptoms.forEach(s => {
				symptoms[s.type].push(s);
			});
			return symptoms;
    }
  }
};
</script>